import React, { useEffect } from 'react';
import { Typography, Container } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { BorderButton } from '../components/CommonComponents/Button';
import { ROUTE_PATH } from '../constants/route';
import { useSelector } from 'react-redux';

const ErrorContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '70vh',
  padding: theme.spacing(4),
  textAlign: 'center',
}));

const ErrorCode = styled(Typography)(({ theme }) => ({
  fontSize: '8rem',
  fontWeight: 700,
  color: theme.palette.secondary.main,
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '6rem',
  },
}));

const ErrorTitle = styled(Typography)(({ theme }) => ({
  fontSize: '2rem',
  fontWeight: 600,
  marginBottom: theme.spacing(2),
  color: theme.palette.primary.main,
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.5rem',
  },
}));

const ErrorMessage = styled(Typography)(({ theme }) => ({
  fontSize: '1.2rem',
  marginBottom: theme.spacing(4),
  color: theme.palette.customColor.secondarySecond,
  maxWidth: '600px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
}));

const StyledButton = styled(BorderButton)(({ theme }) => ({
  maxWidth: '250px',
  marginTop: theme.spacing(2),
}));

const Error404 = () => {
  const navigate = useNavigate();
  const authentication = useSelector((state) => state.authentication);

  // Check for authentication token
  const token = authentication?.auth?.data?.auth_token || 
                authentication?.auth?.data?.data?.auth_token || 
                authentication?.userData?.data?.auth_token || 
                null;

  useEffect(() => {
    // Redirect if no token and trying to access private routes
    if (!token && window.location.pathname.includes('/dashboard')) {
      navigate(ROUTE_PATH.LOGIN);
    }
  }, [token, navigate]);

  const handleBackToHome = () => {
    // Navigate to appropriate home based on authentication status
    if (token) {
      navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
    } else {
      navigate(ROUTE_PATH.DASHBOARD);
    }
  };

  return (
    <ErrorContainer>
      <ErrorCode variant="h1">404</ErrorCode>
      <ErrorTitle variant="h2">Page Not Found</ErrorTitle>
      <ErrorMessage variant="body1">
        We're sorry, the page you requested could not be found. Please check the URL or navigate back to the homepage.
      </ErrorMessage>
      <StyledButton onClick={handleBackToHome}>
        Back to Home
      </StyledButton>
    </ErrorContainer>
  );
};

export default Error404;